var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.container]},[_c('div',{class:_vm.$style.avatarContainer},[_c('div',{class:_vm.$style.avatar},[_vm._v(" "+_vm._s(_vm.avatarText)+" ")])]),_c('div',{class:_vm.$style.contentContainer},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }